import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import {
  Header,
  Image,
  List,
  Table,
  Card,
  Modal,
  Button,
  Popup,
  Grid,
  Segment,
} from "semantic-ui-react";
import Typography from "@mui/material/Typography";
import "../../node_modules/react-vis/dist/style.css";
import "../css/home.css";
import Constants from "../util/Constants";
import uuid from "react-uuid";
import { UserContext } from "../main/MainHome.js";
import CompanyPage from "../company/CompanyPage";
import Utils from "../util/Utils";

export default function EarningsCalendar() {
  const [stateValues, setstateValues] = useState({
    open: false,
    modalSymbol: "",
    loading: true,
  });

  const showModal = (symbol) => {
    setstateValues({ ...stateValues, modalSymbol: symbol, open: true });
  };

  const setOpen = (flag) => {
    setstateValues({ ...stateValues, open: flag });
  };

  const getEarningsList = (earnigsForDay, time) => {
    return (
      <List divided size="large">
        {earnigsForDay &&
          earnigsForDay.map((item) =>
            item.hour === time ? (
              <List.Item
                key={uuid()}
                onClick={() => showModal(item.symbol)}
                style={{
                  cursor: "pointer",
                  padding: "0.3em 0 !important",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.3em",
                }}
              >
                <div
                  style={{
                    flexShrink: 0,
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Image
                    src={item.imageUrl}
                    onError={(e) => {
                      e.target.style.display = "none";
                      const iconBox = document.createElement("div");
                      iconBox.innerHTML =
                        '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>';
                      iconBox.style.display = "flex";
                      iconBox.style.alignItems = "center";
                      iconBox.style.justifyContent = "center";
                      e.target.parentNode.insertBefore(iconBox, e.target);
                    }}
                    style={{
                      mixBlendMode: "multiply",
                      width: "40px",
                      height: "40px",
                      display: "block",
                    }}
                  />
                </div>
                  <List.Content style={{ fontSize: "0.95em", flex: 1 }}>
                  <List.Header style={{ fontSize: "0.98em", fontWeight: "600" }}>
                    <Popup inverted trigger={<p>{item.symbol}</p>} size="large">
                      <Popup.Header>
                        <Header as="h6" image>
                          <Image
                            src={Constants.IMAGE_URL + item.symbol + ".jpg"}
                            rounded
                            onError={(e) => {
                              e.target.style.display = "none";
                              const iconBox = document.createElement("div");
                              iconBox.innerHTML =
                                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>';
                              e.target.parentNode.insertBefore(iconBox, e.target);
                            }}
                          />
                        </Header>
                        {item.symbol}
                      </Popup.Header>
                      <Popup.Content>
                        EPS Estimate:{" "}
                        {Utils.format_currency_usd(item.epsEstimate)}
                      </Popup.Content>
                    </Popup>
                  </List.Header>
                  {item.companyName.split(" ")[0]}
                </List.Content>
              </List.Item>
            ) : null
          )}
      </List>
    );
  };

  const userEmail = useContext(UserContext);

  const [earningsByDate, setEarningsByDate] = useState([]);

  useEffect(() => {
    var urlVal = Constants.EARNINGS_CAL_URL + "?userEmail=" + userEmail;
    axios({
      method: "get",
      responseType: "json",
      url: urlVal,
    })
      .then((response) => {
        setEarningsByDate(response.data.earningsByDate);
      })
      .catch(function (error) {});
  }, [userEmail]);

  return (
    <div style={{ padding: "10px", marginBottom: "56px" }}>
      <Typography
        variant="h5"
        align="center"
        sx={{
          color: "primary.dark",
          fontWeight: 600,
          mb: 0.5,
          mt: 0.5,
          fontSize: { xs: "1.5rem", md: "1.75rem" },
          letterSpacing: "-0.02em",
        }}
      >
        Earnings Calendar{" "}
      </Typography>

      <Grid stackable columns={5} style={{ marginTop: "0.5em", width: "100%" }}>
        {earningsByDate &&
          Object.keys(earningsByDate).map((key) => (
            <Grid.Column
              key={uuid()}
              style={{ padding: "0.3em", minHeight: "450px", overflow: "auto" }}
            >
              <Card fluid style={{ height: "100%" }}>
                <Card.Content
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    padding: "0.3em",
                  }}
                >
                  <Header
                    as="h4"
                    textAlign="center"
                    style={{
                      backgroundColor: "#A9D0F5",
                      padding: "0.25em 0.3em",
                      margin: "0 0 0.2em 0",
                      fontSize: "1.0em",
                      fontWeight: "bold",
                    }}
                  >
                    {key}
                  </Header>
                  <Table celled compact unstackable style={{ flex: 1, fontSize: "0.98em", margin: "0" }}>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell
                          style={{
                            backgroundColor: "#A9D0F5",
                            textAlign: "center",
                            padding: "0.35em",
                            fontSize: "0.88em",
                          }}
                        >
                          Before Market Open
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          style={{
                            backgroundColor: "#A9D0F5",
                            textAlign: "center",
                            padding: "0.35em",
                            fontSize: "0.88em",
                          }}
                        >
                          After Market Close
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell
                          verticalAlign="top"
                          style={{ backgroundColor: "#FBF8EF", height: "100%" }}
                        >
                          {getEarningsList(earningsByDate[key], "bmo")}
                        </Table.Cell>
                        <Table.Cell
                          verticalAlign="top"
                          style={{ backgroundColor: "#FBF8EF", height: "100%" }}
                        >
                          {getEarningsList(earningsByDate[key], "amc")}
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))}
      </Grid>
      <Modal
        closeOnEscape={true}
        onClose={() => setOpen(false)}
        centered={true}
        open={stateValues.open}
        size="fullscreen"
        style={{ marginLeft: "2%" }}
      >
        <Modal.Content scrolling>
          <Modal.Description>
            <CompanyPage symbol={stateValues.modalSymbol} />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button className="ui blue button" onClick={() => setOpen(false)}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
}
